import script from "./ExamStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamStatus.vue?vue&type=script&setup=true&lang=js"

import "./ExamStatus.vue?vue&type=style&index=0&id=1b56f450&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b56f450"]])

export default __exports__